"use strict";
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResendSubTitle = exports.ResendTitle = exports.ReSendOTPContainer = exports.CheckGreenIcon = exports.ErrorText = exports.SubTitleWrapper = exports.RerouteText = exports.CountryCodeText = exports.AccountRecoveryLink = exports.AccountRecoveryText = exports.AccountRecoveryWrapper = exports.GenericFullPageLoginContainer = exports.StyledOTPInput = exports.StyledInput = exports.OTPResendText = exports.SubTitle = exports.Title = exports.ImageContainer = exports.Wrapper = exports.CustomImage = exports.NavigationBarContainer = exports.RightContainer = exports.RootContainer = exports.LeftContainer = exports.Container = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const building_blocks_ui_typography_1 = require("@acko-tech/building-blocks.ui.typography");
const building_blocks_ui_input_1 = require("@acko-tech/building-blocks.ui.input");
exports.Container = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  justify-content: center;
  align-items: center;
`;
exports.LeftContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  width: 50%;
  height: 100vh;
  padding-top: 140px;
  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 100vh;
    padding-top: 0px;
  }
`;
exports.RootContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  @media only screen and (max-width: 768px) {
    height: 100%;
    background-image: url('https://acko-home-prod.ackoassets.com/assets/background-pattern.svg');
    background: url('https://acko-home-prod.ackoassets.com/assets/background-pattern.svg'),
      linear-gradient(180deg, #efe9fb 0%, rgba(239, 233, 251, 0) 100%);
    background-repeat: no-repeat;
    background-size: contain;
    padding: 0 20px;
  }

  background-size: 100% 205px;
  @media (min-width: 360px) {
    background-size: 100% 280px;
  }
  @media (min-width: 490px) {
    background-size: 100% 340px;
  }
  @media (min-width: 590px) {
    background-size: 100% 385px;
  }
  @media (min-width: 630px) {
    background-size: 100% 400px;
  }
  @media (min-width: 680px) {
    margin: 0 auto;
  }
  @media (min-width: 768px) {
    max-width: 330px;
  }
`;
exports.RightContainer = building_blocks_ui_common_1.styled.div `
  @media only screen and (max-width: 768px) {
    display: none;
  }
  width: 50%;
  height: 100vh;
`;
exports.NavigationBarContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  display: none;
  margin-bottom: 32px;
  @media only screen and (max-width: 768px) {
    display: inherit;
  }
`;
exports.CustomImage = building_blocks_ui_common_1.styled.img `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
exports.Wrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  box-sizing: border-box;
  align-items: baseline;
  @media only screen and (max-width: 768px) {
    height: ${(props) => (props.screenHeight ? props.screenHeight : '100vh')};
    ${(props) => props.isGenericPage && `padding-top: 40px;`}
    ${(props) => props.isGenericPage && `height: calc(100vh - 60px);`}
    ${(props) => props.isGenericPage && `justify-content: space-between;;`}
    width: 100%;

    ${(props) => props.iChallansNewFlow &&
    `
        height: 100%;
        justify-content: space-between;
      `}  
  }
`;
exports.ImageContainer = building_blocks_ui_common_1.styled.div `
  width: 90px;
  height: auto;
  margin: ${(props) => (props.isGenericPage ? 'inherit' : '0 auto')};

  @media only screen and (max-width: 768px) {
    width: 80px;
    margin: inherit;
  }
`;
exports.Title = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `  
  font-size: ${(props) => props.theme.typography.fonts.size.T1};
  line-height: ${(props) => props.theme.typography.lineHeights.T1};
  font-weight: ${(props) => props.theme.typography.fonts.weight.T1};
  margin-top: ${(props) => props.theme.spacing[7]};
  color: ${(props) => props.colors.primary.n600};
  text-align: ${(props) => props.iChallansNewFlow ? "left" : "center"}; 
  @media only screen and (max-width: 768px) {
    text-align: left;
    font-size: ${(props) => props.iChallansNewFlow ? props.theme.typography.fonts.size.T1 : props.theme.typography.fonts.size.T2};
    line-height: ${(props) => props.iChallansNewFlow ? props.theme.typography.lineHeights.T1 : props.theme.typography.lineHeights.T2};
    margin-top: ${(props) => props.iChallansNewFlow ? `${props.theme.spacing[4]} !important` : props.theme.spacing[8]};
  }
`;
exports.SubTitle = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-size: ${(props) => props.theme.typography.fonts.size.P2};
  line-height: ${(props) => props.theme.typography.lineHeights.P2};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P2};
  color: ${(props) => props.colors.secondary.n400};
  width: max-content;
`;
exports.OTPResendText = building_blocks_ui_common_1.styled.p `
  font-size: ${(props) => props.theme.typography.fonts.size.P2};
  line-height: ${(props) => props.theme.typography.lineHeights.P2};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P2};
  color: ${(props) => props.colors.secondary.n400};
  width: max-content;
`;
exports.StyledInput = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_input_1.Input) `
  margin: ${(props) => props.theme.spacing[7]}
    ${(props) => props.theme.spacing[0]};
`;
exports.StyledOTPInput = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_input_1.OTPInput) `
  margin: ${(props) => props.theme.spacing[7]}
    ${(props) => props.theme.spacing[0]};
`;
exports.GenericFullPageLoginContainer = building_blocks_ui_common_1.styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  ${(props) => props.alignCenter && `justify-content: center`}
`;
exports.AccountRecoveryWrapper = building_blocks_ui_common_1.styled.div `
  margin-top: ${(props) => props.theme.spacing[6]};
  text-align: center;
  font-size: ${(props) => props.theme.typography.fonts.size.P2};
  line-height: ${(props) => props.theme.typography.lineHeights.P2};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P2};
`;
exports.AccountRecoveryText = building_blocks_ui_common_1.styled.span ``;
exports.AccountRecoveryLink = building_blocks_ui_common_1.styled.a `
  margin-left: ${(props) => props.theme.spacing[1]};
  color: ${(props) => { var _a; return (_a = props.colors) === null || _a === void 0 ? void 0 : _a.blue.b300; }};
  &:hover {
    cursor: pointer;
  }
`;
exports.CountryCodeText = building_blocks_ui_common_1.styled.div `
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  line-height: ${(props) => props.theme.typography.lineHeights.P1};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P1};
  color: ${(props) => props.colors.primary.n600};
`;
exports.RerouteText = building_blocks_ui_common_1.styled.div `
  font-size: ${(props) => props.theme.typography.fonts.size.P2};
  line-height: ${(props) => props.theme.typography.lineHeights.P2};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P2};
  color: ${(props) => props.colors.blue.b300};
  width: max-content;
  margin-left: ${(props) => props.marginLeft ? props.marginLeft : props.theme.spacing[2]};
  &:hover {
    cursor: pointer;
  }
  ${(props) => props.disabled &&
    `color: ${(props) => props.colors.neutral.n300}; cursor: default;pointer-events: none`}
`;
exports.SubTitleWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  margin-bottom: ${(props) => props.iChallansNewFlow ? "0" : props.theme.spacing[8]};  
  margin-top: ${(props) => props.theme.spacing[2]};
`;
exports.ErrorText = (0, building_blocks_ui_common_1.styled)(exports.SubTitle) `
  color: ${(props) => props.colors.red.r400};
`;
exports.CheckGreenIcon = building_blocks_ui_common_1.styled.img `
  width: 24px;
  height: 24px;
`;
exports.ReSendOTPContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  padding: 12px;
  background: #fff7e5;
  border-radius: 12px;
  width: initial;
`;
exports.ResendTitle = building_blocks_ui_common_1.styled.p `
  margin: 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #040222;
`;
exports.ResendSubTitle = building_blocks_ui_common_1.styled.p `
  margin: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #040222;
  margin: 6px 0 12px 0;
`;
//# sourceMappingURL=index.js.map